module.exports = __webpack_public_path__ + "static/media/Tier_8.29d3af54.png";